module.exports = __webpack_public_path__ + "img/schnittkante_beige_ohneral.ce309313.jpg";